import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FeeScheduleService } from '../services/fee-schedule.service';
import {FeeScheduleDoctorDataModel} from '../../../models/fee-schedule/fee-schedule-doctor.model';
import {MessagingService} from "../../../services/messaging.service";


@Component({
    selector: 'app-edit-fee-schedule-doctor',
    templateUrl: './edit-fee-schedule-doctor.component.html',
    styleUrls: ['./edit-fee-schedule-doctor.component.css']
})
export class EditFeeScheduleDoctorComponent implements OnInit {

    isLoading: boolean = false;
    dataDoctor: FeeScheduleDoctorDataModel;
    dataDoctorBackup: FeeScheduleDoctorDataModel;
    isMutipleActiveInsurance : boolean = false;

    constructor(
        public dialogRef: MatDialogRef<EditFeeScheduleDoctorComponent>,
        private messagingService: MessagingService,
        private feeScheduleService: FeeScheduleService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {

console.log(this.data);

        this.dataDoctor = JSON.parse(JSON.stringify(this.data.dataDoctor));
        this.dataDoctorBackup = JSON.parse(JSON.stringify(this.dataDoctor));

    }

    valueIsActiveChange(e: any)  {
        this.dataDoctor.isActive = e.checked;

    }

    close() {
        this.dataDoctor = JSON.parse(JSON.stringify(this.dataDoctorBackup));
        this.dialogRef.close();
    }




    save(isFirstSave: boolean = false) {

      if(isFirstSave) {
        // get list of active fee schedules for this doctor different than current one
        this.feeScheduleService.getAllActiveFeeSchedulesForInsuranceForDoctor(this.dataDoctor)
          .subscribe(response => {
            // if response is array of length > 0 then show  message  y/n to deactivate these and save content or cancel edit action

            if(response.length > 0) {
              this.isMutipleActiveInsurance = true;
            }
            else {
              this.feeScheduleService.editFeeScheduleDoctor(this.dataDoctor)
                .subscribe(response => {
                  this.dialogRef.close(this.dataDoctor);
                }, err => {
                  this.close();
                });
            }


          });
      }
      else {

        this.feeScheduleService.editFeeScheduleDoctor(this.dataDoctor)
          .subscribe(response => {
            this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
            this.dialogRef.close(this.dataDoctor);
          }, err => {
            this.close();
          });
      }
    }

}
